"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPosition = exports.CheckLevel = void 0;
exports.CheckLevel = {
    OK: 100,
    NONE: 0,
    WARNING: -100,
    ERROR: -200,
};
exports.CheckPosition = {
    HEADER: "header",
    DETAIL: "detail",
    JOURNAL: "journal",
};
